import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { PostTradeService } from '../post-trade.service';
import { saveAs } from '@progress/kendo-file-saver';
import { UserReportsListResponse } from '../../models/post-trade-models';

@Component({
  selector: 'app-post-trade-reports',
  templateUrl: './post-trade-reports.component.html',
  styleUrls: ['./post-trade-reports.component.scss'],
  standalone: false,
})
export class PostTradeReportsComponent implements OnInit, OnDestroy {
  private ss = inject(SessionStorageService);
  ptSvc = inject(PostTradeService);
  private route = inject(Router);

  rights = [];
  unsubscribe: Subject<any> = new Subject();
  headers = [
    {
      label: 'Report Name',
      fieldName: 'FileName',
    },
    {
      label: 'Create Date',
      fieldName: 'RequestDate',
      fieldMask: 'date',
    },
    {
      label: 'Category',
      fieldName: 'Category',
    },
  ];
  reports: any[] = [];
  crumbConfig = [
    {
      label: 'Post Transaction',
      link: 'post-trade',
    },
    {
      label: 'Reports',
      link: 'post-trade/reports',
    },
  ];

  ngOnInit(): void {
    this.rights = this.ss.get('rights');

    this.ptSvc
      .getUserReportsList()
      .subscribe((res: UserReportsListResponse) => {
        if (res.Reports) {
          this.reports = res.Reports;
        }
      });
  }

  saveFile(fileID, fileName) {
    this.ptSvc.downloadUserReport(fileID).subscribe((res: Blob) => {
      const filename = `${fileName}.zip`;
      let fileData;
      const reader = new FileReader();

      reader.readAsDataURL(res);
      reader.onloadend = () => {
        fileData = reader.result;
        saveAs(fileData as string, filename);
      };
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }
}
